import { useLayoutEffect, useState } from 'react';
import {
  applyTheme,
  initThemeFromStorage,
  persistTheme,
  type Theme,
} from '../theme/theme';

export const useTheme = (): [Theme, (theme: Theme) => void] => {
  const [theme, setThemeState] = useState<Theme>(initThemeFromStorage);

  useLayoutEffect(() => {
    applyTheme(theme);
    persistTheme(theme);
  }, [theme]);

  return [theme, setThemeState];
};
